"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CustomStyleHooksContext: function() {
        return _index.CustomStyleHooksContext;
    },
    CustomStyleHooksProvider: function() {
        return _index.CustomStyleHooksProvider;
    },
    useCustomStyleHook: function() {
        return _index.useCustomStyleHook;
    }
});
const _index = require("./CustomStyleHooksContext/index");
